module.exports = __webpack_public_path__ + "img/bigCurve.ee148f8d.png";